import { AddressForm } from '@pesto/features/src/UserProfile/components/AddressForm';
import { UserPersonalInfo } from '@pesto/features/src/UserProfile/components/UserPersonalInfo';

import type { UserDetailViewModel } from '../../toUserDetail';

interface UserDetailsTabProps {
  user: UserDetailViewModel;
}

export const UserDetailsTab = ({ user }: UserDetailsTabProps) => {
  return (
    <div className="space-y-4">
      <div className="grid gap-4 lg:grid-cols-2">
        <UserPersonalInfo
          user={{
            id: user.id,
            firstName: user.firstName,
            middleName: user.middleName,
            lastName: user.lastName,
            email: user.email,
            phone: user.phone,
            dob: user.dob,
            insertedAt: user.insertedAt,
            isFriendsAndFam: user.isFriendsAndFam,
          }}
          readOnly
        />
        <AddressForm
          title="Billing Address"
          description="Billing address for this user"
          address={user.billingAddress}
          readOnly
        />
      </div>
    </div>
  );
};
